// dot_show: false,
// number_show: false,

export const typeofbacteria_qpt = {
    core_bacteria: [
        'Akkermansia muciniphila',
        'Faecalibacterium prausnitzii'
    ],
    harmful_bacteria: [
        'Candida albicans',
        'Escherichia coli',
        'Staphylococcus aureus',
        'Ruminococus bromii'
    ],
    beneficial_bacteria: [
        'Bifidobacterium bifidum',
        'Bifidobacterium lactis',
        'Lactobacillus acidophilus',
        'Lactobacillus reuteri',
        'Lactobacillus rhamnosus'
    ],
}

export const typeofbacteria_qptsm = {
    core_bacteria: [
        'A. muciniphila',
        'F. prausnitzii'
    ],
    harmful_bacteria: [
        'C. albicans',
        'E. coli',
        'S. aureus',
        'R. bromii'
    ],
    beneficial_bacteria: [
        'B. bifidum',
        'B. lactis',
        'L. acidophilus',
        'L. reuteri',
        'L. rhamnosus'
    ],
}

export const scoreConfig_AllergyandEczema_allergy = [
    {
        titel: `Allergic rhinitis`,
        match_key: 'Allergic rhinitis',
        Xdotpos: 177,
        Ydotpos: 1025,
        Xnumberpos: 580,
        Ynumberpos: 1000,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 6,
        dot_show: false,
        number_show: false,
        value_use: [
            // 'Bifidobacterium breve',
            'Bifidobacterium lactis',
            // 'Bifidobacterium longum',
            'Lactobacillus acidophilus',
            // 'Lactobacillus paracasei',
            // 'Lactobacillus plantarum'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: `Asthma`,
        match_key: 'Asthma',
        Xdotpos: 177,
        Ydotpos: 715,
        Xnumberpos: 580,
        Ynumberpos: 690,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 6,
        dot_show: false,
        number_show: false,
        value_use: [
            'Akkermansia muciniphila',
            'Faecalibacterium prausnitzi',
            'Candida albican',
            'Bifidobacterium bifidum',
            // 'Bifidobacterium breve',
            // 'Lactobacillus plantarum',
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 100, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: `Eczema`,
        match_key: 'Eczema',
        Xdotpos: 177,
        Ydotpos: 920,
        Xnumberpos: 580,
        Ynumberpos: 895,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 6,
        dot_show: false,
        number_show: false,        
        value_use: [
            'Faecalibacterium prausnitzii',
            'Escherichia coli',
            'Staphylococcus aureus',
            'Bifidobacterium bifidum',
            // 'Bifidobacterium breve',
            'Lactobacillus acidophilus',
            'Lactobacillus rhamnosus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: `Food allergy`,
        match_key: 'Food allergy',
        Xdotpos: 177,
        Ydotpos: 816,
        Xnumberpos: 580,
        Ynumberpos: 790,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 6,
        dot_show: false,
        number_show: false,            
        value_use: [
            // 'Bacteroidetes phylum',
            // 'Bacteroides fragilis',
            'Bifidobacterium bifidum',
            // 'Bifidobacterium breve',
            // 'Bifidobacterium longum',
            // 'Lactobacillus plantarum',
            // 'Streptococcus thermophilus'

          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
]
